package com.eladfinish.bible.contest.domain.catalog

import kotlinx.collections.immutable.toImmutableList

@Suppress("SpellCheckingInspection")
object BibleCatalog {
    val books: List<BookData> = listOf(
        BookData(
            hebrew = "בראשית",
            trans = "bereshit",
            english = "Genesis",
            numberOfChapters = 50
        ),
        BookData(
            hebrew = "שמות",
            trans = "shemot",
            english = "Exodus",
            numberOfChapters = 40
        ),
        BookData(
            hebrew = "ויקרא",
            trans = "vayikra",
            english = "Leviticus",
            numberOfChapters = 27
        ),
        BookData(
            hebrew = "במדבר",
            trans = "bamidbar",
            english = "Numbers",
            numberOfChapters = 36
        ),
        BookData(
            hebrew = "דברים",
            trans = "devarim",
            english = "Deuteronomy",
            numberOfChapters = 34
        ),
        BookData(
            hebrew = "יהושע",
            trans = "yehoshua",
            english = "Joshua",
            numberOfChapters = 24
        ),
        BookData(
            hebrew = "שופטים",
            trans = "shoftim",
            english = "Judges",
            numberOfChapters = 21
        ),
        BookData(
            hebrew = "שמואל א",
            trans = "shemuel_a",
            english = "1 Samuel",
            numberOfChapters = 31
        ),
        BookData(
            hebrew = "שמואל ב",
            trans = "shemuel_b",
            english = "2 Samuel",
            numberOfChapters = 24
        ),
        BookData(
            hebrew = "מלכים א",
            trans = "melachim_a",
            english = "1 Kings",
            numberOfChapters = 22
        ),
        BookData(
            hebrew = "מלכים ב",
            trans = "melachim_b",
            english = "2 Kings",
            numberOfChapters = 25
        ),
        BookData(
            hebrew = "ישעיהו",
            trans = "yeshaaya",
            english = "Isaiah",
            numberOfChapters = 66
        ),
        BookData(
            hebrew = "ירמיהו",
            trans = "yirmeyah",
            english = "Jeremiah",
            numberOfChapters = 52
        ),
        BookData(
            hebrew = "יחזקאל",
            trans = "yechezkel",
            english = "Ezekiel",
            numberOfChapters = 48
        ),
        BookData(
            hebrew = "הושע",
            trans = "hoshea",
            english = "Hosea",
            numberOfChapters = 14
        ),
        BookData(
            hebrew = "יואל",
            trans = "yoel",
            english = "Joel",
            numberOfChapters = 4
        ),
        BookData(
            hebrew = "עמוס",
            trans = "amos",
            english = "Amos",
            numberOfChapters = 9
        ),
        BookData(
            hebrew = "עובדיה",
            trans = "ovadia",
            english = "Obadiah",
            numberOfChapters = 1
        ),
        BookData(
            hebrew = "יונה",
            trans = "yona",
            english = "Jonah",
            numberOfChapters = 4
        ),
        BookData(
            hebrew = "מיכה",
            trans = "micha",
            english = "Micah",
            numberOfChapters = 7
        ),
        BookData(
            hebrew = "נחום",
            trans = "nachum",
            english = "Nahum",
            numberOfChapters = 3
        ),
        BookData(
            hebrew = "חבקוק",
            trans = "havakuk",
            english = "Habakkuk",
            numberOfChapters = 3
        ),
        BookData(
            hebrew = "צפניה",
            trans = "tzefania",
            english = "Zephaniah",
            numberOfChapters = 3
        ),
        BookData(
            hebrew = "חגי",
            trans = "haggai",
            english = "Haggai",
            numberOfChapters = 2
        ),
        BookData(
            hebrew = "זכריה",
            trans = "zecharia",
            english = "Zechariah",
            numberOfChapters = 14
        ),
        BookData(
            hebrew = "מלאכי",
            trans = "malachi",
            english = "Malachi",
            numberOfChapters = 3
        ),
        BookData(
            hebrew = "תהילים",
            trans = "tehilim",
            english = "Psalm",
            numberOfChapters = 150
        ),
        BookData(
            hebrew = "משלי",
            trans = "mishley",
            english = "Proverbs",
            numberOfChapters = 31
        ),
        BookData(
            hebrew = "איוב",
            trans = "iyov",
            english = "Job",
            numberOfChapters = 42
        ),
        BookData(
            hebrew = "שיר השירים",
            trans = "shir_hashirim",
            english = "Song of Solomon",
            numberOfChapters = 8
        ),
        BookData(
            hebrew = "רות",
            trans = "ruth",
            english = "Ruth",
            numberOfChapters = 4
        ),
        BookData(
            hebrew = "איכה",
            trans = "eicha",
            english = "Lamentations",
            numberOfChapters = 5
        ),
        BookData(
            hebrew = "קהלת",
            trans = "koheleth",
            english = "Ecclesiastes",
            numberOfChapters = 12
        ),
        BookData(
            hebrew = "אסתר",
            trans = "ester",
            english = "Esther",
            numberOfChapters = 10
        ),
        BookData(
            hebrew = "דניאל",
            trans = "daniel",
            english = "Daniel",
            numberOfChapters = 12
        ),
        BookData(
            hebrew = "עזרא",
            trans = "ezra",
            english = "Ezra",
            numberOfChapters = 10
        ),
        BookData(
            hebrew = "נחמיה",
            trans = "nechemia",
            english = "Nehemiah",
            numberOfChapters = 13
        ),
        BookData(
            hebrew = "דברי הימים א",
            trans = "divrei_hayamim_a",
            english = "1 Chronicles",
            numberOfChapters = 29
        ),
        BookData(
            hebrew = "דברי הימים ב",
            trans = "divrei_hayamim_b",
            english = "2 Chronicles",
            numberOfChapters = 36
        ),
    ).toImmutableList()
}
